import marbellaHuracan from "@/assets/marbella-huracan-spyder.webp";
import marbellaFerrariF8 from "@/assets/marbella-ferrari-f8.webp";
import marbellaLamboUrus from "@/assets/marbella-lambo-urus.webp";
import marbellaG63 from "@/assets/marbella-g63.webp";
import marbellaPorsche911 from "@/assets/marbella-porsche-911.webp";
import marbellaRRSport from "@/assets/marbella-rr-sport.webp";

export interface MarbellaCar {
  slug: string;
  name: string;
  image: string;
  gallery?: string[];
  price: string;
  specs: { label: string; value: string }[];
  description: string;
}

export const marbellaCars: MarbellaCar[] = [
  {
    slug: "lamborghini-huracan-evo-spyder",
    name: "Lamborghini Huracán EVO Spyder",
    image: marbellaHuracan,
    gallery: [marbellaHuracan],
    price: "From €1.500/day",
    specs: [
      { label: "Passengers", value: "2" },
      { label: "Engine", value: "5.2L V10" },
      { label: "Power", value: "640 HP" },
      { label: "0–100 km/h", value: "3.1 sec" },
      { label: "Top Speed", value: "325 km/h" },
    ],
    description:
      "Raw, visceral, and utterly captivating. The Huracán EVO Spyder delivers an open-air supercar experience that transforms every coastal road in Marbella into an event.",
  },
  {
    slug: "ferrari-f8-spider",
    name: "Ferrari F8 Spider",
    image: marbellaFerrariF8,
    gallery: [marbellaFerrariF8],
    price: "From €1.700/day",
    specs: [
      { label: "Passengers", value: "2" },
      { label: "Engine", value: "3.9L V8" },
      { label: "Power", value: "720 HP" },
      { label: "0–100 km/h", value: "2.9 sec" },
      { label: "Top Speed", value: "340 km/h" },
    ],
    description:
      "An open-top masterpiece delivering breathtaking performance and unmistakable presence. The F8 Spider transforms every drive along the Costa del Sol into an unforgettable experience.",
  },
  {
    slug: "lamborghini-urus-s",
    name: "Lamborghini Urus S",
    image: marbellaLamboUrus,
    gallery: [marbellaLamboUrus],
    price: "From €1.200/day",
    specs: [
      { label: "Passengers", value: "5" },
      { label: "Engine", value: "4.0L V8 Biturbo" },
      { label: "Power", value: "660 HP" },
      { label: "0–100 km/h", value: "3.5 sec" },
      { label: "Top Speed", value: "305 km/h" },
    ],
    description:
      "The world's first Super SUV — combining Lamborghini's unmistakable design DNA with everyday versatility and commanding presence on the road.",
  },
  {
    slug: "mercedes-amg-g63",
    name: "Mercedes-AMG G63",
    image: marbellaG63,
    gallery: [marbellaG63],
    price: "From €800/day",
    specs: [
      { label: "Passengers", value: "5" },
      { label: "Engine", value: "4.0L V8 Biturbo" },
      { label: "Power", value: "585 HP" },
      { label: "0–100 km/h", value: "4.5 sec" },
      { label: "Top Speed", value: "220 km/h" },
    ],
    description:
      "An icon of automotive design. The G63 AMG combines unmistakable presence with refined luxury and effortless power across any terrain.",
  },
  {
    slug: "porsche-911-carrera-cabrio",
    name: "Porsche 911 Carrera Cabrio",
    image: marbellaPorsche911,
    gallery: [marbellaPorsche911],
    price: "From €700/day",
    specs: [
      { label: "Passengers", value: "4" },
      { label: "Engine", value: "3.0L Flat-6" },
      { label: "Power", value: "385 HP" },
      { label: "0–100 km/h", value: "4.2 sec" },
      { label: "Top Speed", value: "293 km/h" },
    ],
    description:
      "Timeless design meets exhilarating performance. The 911 Carrera Cabrio delivers a driving experience that perfectly complements the spirit of the Costa del Sol.",
  },
  {
    slug: "range-rover-sport",
    name: "Range Rover Sport",
    image: marbellaRRSport,
    gallery: [marbellaRRSport],
    price: "From €500/day",
    specs: [
      { label: "Passengers", value: "5" },
      { label: "Engine", value: "3.0L I6" },
      { label: "Power", value: "400 HP" },
      { label: "0–100 km/h", value: "5.8 sec" },
      { label: "Top Speed", value: "242 km/h" },
    ],
    description:
      "Commanding presence meets refined comfort. The Range Rover Sport is the ideal companion for navigating Marbella in style and ease.",
  },
];
